import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {inject, onMounted, ref} from "vue";
import {AxiosStatic} from "axios";
import Panel from "primevue/panel";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import {BalanceType} from "@/components/blocks/Types";
import {formatDate, formatPrice} from "../../services/FormatService";

// Define types

// Define inject

export default /*#__PURE__*/_defineComponent({
  __name: 'BalanceOverview',
  setup(__props) {


const axios = inject<AxiosStatic>('axios')

// Define refs

const items = ref<BalanceType[]>([])
const loading = ref<boolean>(true)
const dt = ref(null);
const pageIndex = ref<number>(0)
const pageSize = ref<number>(12)
const totalRecords = ref<number>(0)
const profit = ref<number>(0)
const yearProfit = ref<number>(0)


// Define lifecycle hooks
onMounted(() => {
  loadData()
})

// Define functions
function loadData() {
  loading.value = true
  axios?.get("/balance").then(response => {
    if (response.status == 200 && response.data.success === true) {
      items.value = response.data.data
      totalRecords.value = response.data.data.length
      loading.value = false
      profit.value = items.value.map(item => item.income + item.outcome).reduce((acc, current) => acc + current, 0.0)
      yearProfit.value = items.value.slice(0, 12).map(item => item.income + item.outcome).reduce((acc, current) => acc + current, 0.0)
    } else {
      console.error('Can not load balance from server', response)
      loading.value = false
    }
  })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Panel), {
    header: "Balance Overview",
    class: "mt-2"
  }, {
    default: _withCtx(() => [
      _createElementVNode("h2", null, [
        _createTextVNode(" Profit: "),
        _createElementVNode("span", {
          class: _normalizeClass({'loss': profit.value<0, 'low': profit.value<10000})
        }, _toDisplayString(_unref(formatPrice)(profit.value)), 3),
        _createTextVNode(" (" + _toDisplayString(items.value.length) + " měsíců) | ", 1),
        _createElementVNode("span", {
          class: _normalizeClass({'loss': yearProfit.value<0, 'low': yearProfit.value<10000})
        }, _toDisplayString(_unref(formatPrice)(yearProfit.value)), 3),
        _createTextVNode(" (12 měsíců) ")
      ]),
      _createVNode(_unref(DataTable), {
        headerStyle: "color:red !important",
        page: pageIndex.value+1,
        ref_key: "dt",
        ref: dt,
        dataKey: "id",
        value: items.value,
        paginator: true,
        rows: pageSize.value,
        rowHover: true,
        totalRecords: totalRecords.value,
        loading: loading.value
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Column), {
            field: "month",
            header: "Datum"
          }, {
            body: _withCtx(({data}) => [
              _createTextVNode(_toDisplayString(_unref(formatDate)(data.month)), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            field: "income",
            header: "Příjem"
          }, {
            body: _withCtx(({data}) => [
              _createTextVNode(_toDisplayString(_unref(formatPrice)(data.income)), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            field: "outcome",
            header: "Výdaj"
          }, {
            body: _withCtx(({data}) => [
              _createTextVNode(_toDisplayString(_unref(formatPrice)(data.outcome)), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), { header: "Rozdíl" }, {
            body: _withCtx(({data}) => [
              _createElementVNode("span", {
                class: _normalizeClass({'loss': (data.income + data.outcome)<0, 'low': (data.income + data.outcome)<10000})
              }, _toDisplayString(_unref(formatPrice)(data.income + data.outcome)), 3)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["page", "value", "rows", "totalRecords", "loading"])
    ]),
    _: 1
  }))
}
}

})